"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = require("react");

var _deepmerge = require("deepmerge");

var _context = _interopRequireDefault(require("./context"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var useReactlytics = function useReactlytics(overrideAnalytics) {
  var oldAnalytics = (0, _react.useContext)(_context.default);
  var mergedAnalytics = (0, _react.useMemo)(function () {
    var localContext = (0, _deepmerge.all)([oldAnalytics, overrideAnalytics || {}]);
    var disable = localContext.disable,
        __originalTrack = localContext.track;
    var track = !disable ? function () {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return __originalTrack((0, _deepmerge.all)([localContext, options]));
    } : function () {};
    return (0, _deepmerge.all)([localContext, {
      track: track
    }]);
  }, [oldAnalytics, overrideAnalytics]);
  return mergedAnalytics;
};

var _default = useReactlytics;
exports.default = _default;